import { QueryCache, QueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { sessionExpired } from '@/lib/auth/authSession'
import { queryErrorEventBus } from '@/lib/misc/EventBus'
import { Notify } from '@/lib/misc/Notify'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error: unknown, query: any) => {
      const response = axios.isAxiosError(error) ? error.response : undefined
      queryErrorEventBus.emit('query:error', { error, query, response })
      const queryError = query.options.meta?.error
      const shouldIgnore =
        typeof queryError?.ignore === 'function'
          ? queryError.ignore(error)
          : queryError?.ignore
      if (shouldIgnore) {
        return
      }

      if (response && response.status === 401) {
        sessionExpired()
      }

      if (queryError?.message) {
        Notify.error(queryError.message)
      }
      const logMsg =
        error instanceof Error ? error.message : 'Unknown query error'
      console.log(logMsg) // eslint-disable-line
    },
  }),
})
